module.exports = __webpack_public_path__ + "static/img/logo.45fcc00b.png";